<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="changeOrderStatusConfirmationDateModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dyspozycja DW</h5>

            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="error" class="alert alert-danger" role="alert">
              {{ error }}
            </div>

            <div class="col-md-12 col-lg-3">

              <label for="receivingPerson">Osoba przyjmująca*</label>
              <input type="text" v-model="receivingPerson" class="form-control form-control-sm">
              <div id="receivingPersonEmptyMessage" class="text-danger" style="display: none">Trzeba wpisać osobę
                przyjmującą
              </div>
            </div>
            <div class="col-md-12 col-lg-3">

              <label for="additional_comment">Dodatkowy komentarz</label>
              <textarea v-model="additional_comment" class="form-control form-control-sm"></textarea>
            </div>
            <div class="table-responsive mt-5">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Nr poz.</th>
                  <th>Podzespół nr rysunku</th>
                  <th>Nr katalogowy</th>
                  <th>Model</th>
                  <th>Nazwa/Opis</th>
                  <th>Projekt</th>
                  <th>Zespół</th>
                  <th>Ilość wymagana</th>
                  <th>Ilość magazynowa</th>
                  <th>Ilość</th>
                  <th>Nr dokumentu</th>
                  <th>Status</th>
                  <th>Status Mag</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in selectedRecords">
                  <td>{{ record.id }}</td>
                  <td>{{ record.subteam_drawing_no }}</td>
                  <td>{{ record.article?.catalog_number || '' }}</td>
                  <td>{{ record.article.model }}</td>
                  <td>{{ record.article.description }}</td>
                  <td :title="record.project.name">{{ record.project.name.slice(0, 30) }}...</td>
                  <td>{{ record.team_name }}</td>
                  <td>{{ record.quantity_to_order }}</td>
                  <td>{{ record.article_main_warehouse?.quantity || 'Brak na mag. głównym' }}</td>
                  <td>
				   <div class="input-group" v-if="payload[record.id]" style="min-width: 140px;">

          <input type="number" 
		  :min="isIntegerUnit(record.article?.article_unit.name) ? 0 : 0.01" 
		  :step="isIntegerUnit(record.article?.article_unit.name) ? 1 : 0.01"  
		  @keydown="blockNonNumeric($event, record.article_unit?.name)"
		  v-model="payload[record.id].quantity" class="form-control form-control-sm" style="min-width: 60px;">

					  
<!-- 
<input type="number" step="0.1" min="0" v-model="payload[record.id].quantity" class="form-control form-control-sm" style="min-width: 30px;" :disabled="!record.article_main_warehouse || record.article_main_warehouse.quantity <= 0">
-->
          <span class="input-group-text">
            {{ record.article?.article_unit.name }}
          </span>

        </div>
                  </td>
                  <td>{{ documentNumber }}</td>
                  <td>{{ record.status }}</td>
                  <td>{{ record.inventory_status?.name }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>

            <form @submit.prevent="submitAsDraft">
              <button type="submit" class="btn btn-outline-primary">
                <i class="bi bi-pen me-2"></i>Zapisz jako robocze
              </button>
            </form>

            <form @submit.prevent="submitForm">
              <button type="submit" class="btn btn-primary">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
            <form @submit.prevent="submitFormClose">
              <button type="submit" class="btn btn-secondary">
                <i class="bi bi-save me-2"></i>Zapisz i zamknij DW
              </button>
            </form>			
          </div>
        </div>
      </div>
    </div>

    <!-- Draft name modal -->
      <div class="modal fade" ref="draftModalEle" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-sm">
          <div class="modal-content">

            <div class="modal-header">
              <h5 class="modal-title">Nazwa robocza dyspozycji</h5>
              <button type="button" class="btn-close" @click="hideDraftModal"></button>
            </div>

            <div class="modal-body">
              <label class="form-label">Nazwa*</label>
              <input
                  type="text"
                  v-model="draftName"
                  class="form-control form-control-sm"
                  placeholder="np. projekt X – test"
              />
              <div v-if="draftNameError" class="text-danger mt-1">
                Nazwa jest wymagana
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary btn-sm" @click="hideDraftModal">
                Anuluj
              </button>
              <button class="btn btn-primary btn-sm" @click="confirmDraft">
                Zapisz draft
              </button>
            </div>

          </div>
        </div>
      </div>

  </div>

</template>

<script>
import {Modal} from "bootstrap";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";
import {nextTick} from "vue";
import toast from "bootstrap/js/src/toast.js";

export default {
  components: {
    "ejs-datepicker": DatePickerComponent
  },

  props: {
    selectedRecords: Object,
    statuses: Object
  },

  data() {

    return {
      newSelectedDate: null,
      error: null,
      articleWarehouses: [],
      receivingPerson: null,
      additional_comment: null,
	  closeDW: null,
      documentNumber: null,
      payload: {},
      draftName: '',
      draftNameError: false,
      draftModalObj: null
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle, {
      backdrop: 'static',
      keyboard: false
    });

    this.draftModalObj = new Modal(this.$refs.draftModalEle, {
      backdrop: true,
      keyboard: false
    });
    this.loadArticleWarehouses();
	
	this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
  
  },

  watch: {
    selectedRecords: {
      handler(newVal) {
	   
        this.payload = {};
        if (!newVal || !Array.isArray(newVal)) return;

        // generuj nr dokumentu;
        this.generateDocumentNumber();

        // dla każdego rekordu twórz payload z pustymi polami, jeśli nie istnieje
        newVal.forEach(record => {
          if (!this.payload[record.id]) {
            this.$set(this.payload, record.id, {
              requiredProjectItemId: record.id,
              articleId: record.article.id,
              fromWarehouseId: 1, // zaznacz defaultowo magazyn główny
              toWarehouseId: null, // zaznacz defaultowo magazyn docelowy dla konkretnego wiersza
              quantity: record.quantity_to_order || 0
            });
          }
        });
      },
      immediate: true
    }
  },

  methods: {
  isIntegerUnit(unitName) {
    return unitName && ['szt', 'szt.', 'kpl'].includes(unitName.toLowerCase());
  },

  // Blokuje niecyfrowe znaki dla jednostek całkowitych
blockNonNumeric(event, unitName) {
  const allowedKeys = [
    'Backspace','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Delete','Tab'
  ];

  if (allowedKeys.includes(event.key)) return;

  if (this.isIntegerUnit(unitName)) {
    if (!/^\d$/.test(event.key)) event.preventDefault();
  } else {
    if (!/^[\d.,]$/.test(event.key)) event.preventDefault();
  }
},

    async loadArticleWarehouses() {
      try {
        const response = await axios.get(route('get.article-warehouses'));
        this.articleWarehouses = response.data;
      } catch (error) {
        console.error('Błąd podczas pobierania magazynów', error);
      }
    },

    async generateDocumentNumber() {
      const response = await axios.get(
          route('warehouse-movements.generate-document-number-json', {
            document_type: 'dw'
          })
      );
      this.documentNumber = response.data.number;
    },

submitForm() {
  // walidacja
  if (!this.receivingPerson) {
    document.getElementById('receivingPersonEmptyMessage').style.display = 'block';
    return;
  } else {
    document.getElementById('receivingPersonEmptyMessage').style.display = 'none';
  }

  // debug (opcjonalnie – bardzo pomaga)

  // 🚨 KLUCZOWA ZMIANA: dane w BODY, nie w URL
  axios.post(
    route('requiredProjectItems.disposition-dw'),
    {
      dispositions: this.payload,
      receivingPerson: this.receivingPerson,
      documentNumber: this.documentNumber,
	  warehouse_id: this.warehouse_id,
	  additional_comment: this.additional_comment,
	  closeDW: this.closeDW
    }
  )
  .then((response) => {
    this.$emit('added-success', response.data.message);
    this.$emit('updated-article');
	this.$emit('clear-selection');
    this.hide();
  })
  .catch((error) => {
    console.log(error.response.data);
    console.log('error', error);

    // 🔍 pokaż dokładny błąd z backendu
    if (error.response) {
      console.log('response data:', error.response.data);
      console.log('status:', error.response.status);
    }
  });
},

submitFormClose() {
  if (!this.receivingPerson) {
    document.getElementById('receivingPersonEmptyMessage').style.display = 'block';
    return;
  } else {
    document.getElementById('receivingPersonEmptyMessage').style.display = 'none';
  }
  this.closeDW = 1;
  axios.post(
    route('requiredProjectItems.disposition-dw'),
    {
      dispositions: this.payload,
      receivingPerson: this.receivingPerson,
      documentNumber: this.documentNumber,
	  warehouse_id: this.warehouse_id,
	  additional_comment: this.additional_comment,
	  closeDW: this.closeDW
    }
  )
  .then((response) => {
    this.$emit('added-success', response.data.message);
    this.$emit('updated-article');
	this.$emit('clear-selection');
    this.hide();
  })
  .catch((error) => {
    console.log('error', error);

    // 🔍 pokaż dokładny błąd z backendu
    if (error.response) {
      console.log('response data:', error.response.data);
      console.log('status:', error.response.status);
    }
  });
},
    submitAsDraft() {
      this.draftName = '';
      this.draftNameError = false;

      this.draftModalObj.show();

      nextTick(() => {
        const backdrops = document.querySelectorAll('.modal-backdrop');
        if (backdrops.length > 1) {
          // Ustawiamy drugie tło wyżej niż pierwszy modal
          backdrops[1].style.zIndex = "1060";
        }
      });
    },
    confirmDraft() {
      if (!this.draftName.trim()) {
        this.draftNameError = true;
        return;
      }

      axios.post(route('requiredProjectItems.disposition-dw-draft'), {
        dispositions: this.payload,
        receivingPerson: this.receivingPerson,
		additional_comment: this.additional_comment,
        draftName: this.draftName
      }).then(resp => {
        this.$emit('added-success', resp.data.message);
        this.hideDraftModal();
        this.hide();
      }).catch(err => {
        console.error(err);
        Toast.fire({
          position: 'top-end',
          toast: true,
          icon: 'error',
          title: 'Coś poszło nie tak',
          html: err.response?.data?.message,
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 1500,
          timerProgressBar: true,
          showConfirmButton: false,
          showCloseButton: true
        })
      });
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
    hideDraftModal() {
      this.draftModalObj.hide();
    }
  }
};

</script>

<style scoped>
/* Pierwszy modal (tło) */
.modal-backdrop {
  z-index: 1050;
}
#changeOrderStatusConfirmationDateModal {
  z-index: 1055;
}

/* Drugi modal (draft) i jego dedykowane tło */
/* Musimy celować w ostatnie dodane tło */
.modal-stack .modal-backdrop:last-of-type {
  z-index: 1060 !important;
}

/* Referencja do ref="draftModalEle" */
div[ref="draftModalEle"],
.modal:nth-of-type(2) {
  z-index: 1065 !important;
}

</style>